module.exports = __webpack_public_path__ + "static/media/call.015f2b3c.svg";